import { render } from "./CampaignAnalytics.vue?vue&type=template&id=048b5e1a"
import script from "./CampaignAnalytics.vue?vue&type=script&lang=js"
export * from "./CampaignAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__